// Rutas que se generan automáticamente
const rutasDeFormularios = [
  { path: 'accesosesion', name: 'AccesoSesion', component: 'AccesoSesion' },
  { path: 'anataten', name: 'AnatAten', component: 'AnatAten' },
  { path: 'anatomia', name: 'Anatomia', component: 'Anatomia' },
  { path: 'anteaten', name: 'AnteAten', component: 'AnteAten' },
  { path: 'antecedente', name: 'Antecedente', component: 'Antecedente' },
  { path: 'asegurador', name: 'Asegurador', component: 'Asegurador' },
  { path: 'asiento', name: 'Asiento', component: 'Asiento' },
  { path: 'atencion', name: 'Atencion', component: 'Atencion' },
  { path: 'atencionfacturacion', name: 'AtencionFacturacion', component: 'AtencionFacturacion' },
  { path: 'atenciondet', name: 'AtencionDet', component: 'AtencionDet' },
  { path: 'aviso', name: 'Aviso', component: 'Aviso' },
  { path: 'biomaten', name: 'BiomAten', component: 'BiomAten' },
  { path: 'biometria', name: 'Biometria', component: 'Biometria' },
  { path: 'cita', name: 'Cita', component: 'Cita' },
  { path: 'clasdiag', name: 'ClasDiag', component: 'ClasDiag' },
  { path: 'claselem', name: 'ClasElem', component: 'ClasElem' },
  { path: 'consejo', name: 'Consejo', component: 'Consejo' },
  { path: 'diagaten', name: 'DiagAten', component: 'DiagAten' },
  { path: 'diagnostico', name: 'Diagnostico', component: 'Diagnostico' },
  { path: 'dosis', name: 'Dosis', component: 'Dosis' },
  { path: 'elemento', name: 'Elemento', component: 'Elemento' },
  { path: 'elemgrup', name: 'ElemGrup', component: 'ElemGrup' },
  { path: 'elemempr', name: 'ElemEmpr', component: 'ElemEmpr' },
  { path: 'empresa', name: 'Empresa', component: 'Empresa' },
  { path: 'empresaimg', name: 'EmpresaImg', component: 'EmpresaImg' },
  { path: 'especialidad', name: 'Especialidad', component: 'Especialidad' },
  { path: 'especita', name: 'EspeCita', component: 'EspeCita' },
  { path: 'estadocivil', name: 'EstadoCivil', component: 'EstadoCivil' },
  { path: 'examaten', name: 'ExamAten', component: 'ExamAten' },
  { path: 'examen', name: 'Examen', component: 'Examen' },
  { path: 'espeempr', name: 'EspeEmpr', component: 'EspeEmpr' },
  { path: 'espemedi', name: 'EspeMedi', component: 'EspeMedi' },
  { path: 'examenfisico', name: 'ExamenFisico', component: 'ExamenFisico' },
  { path: 'existencia', name: 'Existencia', component: 'Existencia' },
  { path: 'factura', name: 'Factura', component: 'Factura' },
  { path: 'facturadet', name: 'FacturaDet', component: 'FacturaDet' },
  { path: 'fechacita', name: 'FechaCita', component: 'FechaCita' },
  { path: 'formapago', name: 'FormaPago', component: 'FormaPago' },
  { path: 'frecuencia', name: 'Frecuencia', component: 'Frecuencia' },
  { path: 'grupoetareo', name: 'GrupoEtareo', component: 'GrupoEtareo' },
  { path: 'horario', name: 'Horario', component: 'Horario' },
  { path: 'impuesto', name: 'Impuesto', component: 'Impuesto' },
  { path: 'localidad', name: 'Localidad', component: 'Localidad' },
  { path: 'medico', name: 'Medico', component: 'Medico' },
  { path: 'mediocom', name: 'MedioCom', component: 'MedioCom' },
  { path: 'mediocomimg', name: 'MedioComImg', component: 'MedioComImg' },
  { path: 'medioemp', name: 'MedioEmp', component: 'MedioEmp' },
  { path: 'mediopers', name: 'MedioPers', component: 'MedioPers' },
  { path: 'modulo', name: 'Modulo', component: 'Modulo' },
  { path: 'moduplan', name: 'ModuPlan', component: 'ModuPlan' },
  { path: 'moduusua', name: 'ModuUsua', component: 'ModuUsua' },
  { path: 'motivoref', name: 'MotivoRef', component: 'MotivoRef' },
  { path: 'pago', name: 'Pago', component: 'Pago' },
  { path: 'parametro', name: 'Parametro', component: 'Parametro' },
  { path: 'paremp', name: 'ParEmp', component: 'ParEmp' },
  { path: 'pedido', name: 'Pedido', component: 'Pedido' },
  { path: 'pedidodet', name: 'PedidoDet', component: 'PedidoDet' },
  { path: 'perfil', name: 'Perfil', component: 'Perfil' },
  { path: 'persona', name: 'Persona', component: 'Persona' },
  { path: 'plan', name: 'Plan', component: 'Plan' },
  { path: 'plancontable', name: 'PlanContable', component: 'PlanContable' },
  { path: 'receta', name: 'Receta', component: 'Receta' },
  { path: 'recetadet', name: 'RecetaDet', component: 'RecetaDet' },
  { path: 'referencia', name: 'Referencia', component: 'Referencia' },
  { path: 'rol', name: 'Rol', component: 'Rol' },
  { path: 'rolmodu', name: 'RolModu', component: 'RolModu' },
  { path: 'sesion', name: 'Sesion', component: 'Sesion' },
  { path: 'sesionerr', name: 'SesionErr', component: 'SesionErr' },
  { path: 'suscpago', name: 'SuscPago', component: 'SuscPago' },
  { path: 'suscripcion', name: 'Suscripcion', component: 'Suscripcion' },
  { path: 'suscripcionaud', name: 'SuscripcionAud', component: 'SuscripcionAud' },
  { path: 'tablmodu', name: 'TablModu', component: 'TablModu' },
  { path: 'tipoelem', name: 'TipoElem', component: 'TipoElem' },
  { path: 'tipoexamen', name: 'TipoExamen', component: 'TipoExamen' },
  { path: 'tipoiden', name: 'TipoIden', component: 'TipoIden' },
  { path: 'tratamiento', name: 'Tratamiento', component: 'Tratamiento' },
  { path: 'usuario', name: 'Usuario', component: 'Usuario' },
  { path: 'signature', name: 'Signature', component: 'Signature' },
];

// Rutas que necesitan mantenerse independientes debido a los parámetros
const rutasIndependientes = [
  { path: '/archivo/:idPedido', name: 'Archivo', component: 'Archivo' },
  { path: '/interconsultaatencion/:p_idatencion', name: 'InterconsultaAtencion', component: 'InterconsultaAtencion' },
  { path: '/interconsultamedico/:p_idmedico', name: 'InterconsultaMedico', component: 'InterconsultaMedico' },
  { path: '/plandiag/:p_idinterconsulta', name: 'PlanDiag', component: 'PlanDiag' },
  { path: '/plantera/:p_idinterconsulta', name: 'PlanTera', component: 'PlanTera' },
  { path: '/tramite-autorizaciones/:p_idtramite', name: 'AutorizacionTramite', component: 'AutorizacionTramite' },
];

// Genera dinámicamente las rutas a partir de las definiciones automáticas
const routes = rutasDeFormularios.map(({ path, name, component }) => ({
  path: `/${path}`,
  name,
  // Importación dinámica para lograr la carga diferida de componentes de ruta
  component: () => import(`../views/forms/${component}.vue`)
}));

// Agrega las rutas que necesitan mantenerse independientes
routes.push(...rutasIndependientes.map(({ path, name, component }) => ({
  path,
  name,
  component: () => import(`../views/forms/${component}.vue`)
})));

export default routes;
